import React from "react";
import "./NoticeBoard.scss";

import cashDividend2023 from "../../../files/notice-board/Cash-Dividend-2023.pdf";
import cashDividend2022 from "../../../files/notice-board/cash-dividend-2022.pdf";
import cashDividend2021 from "../../../files/notice-board/cash-dividend-2021.pdf";
import essayCompetition2024 from "../../../files/notice-board/Essay Competition(2024).pdf";

import proxyForm36 from "../../../files/notice-board/36th-AGM-Proxy-Form.pdf";
import proxyForm35 from "../../../files/notice-board/35th AGM Proxy Form.png";
import proxyForm34 from "../../../files/notice-board/34th AGM Proxy Form.pdf";

import agm28 from "../../../files/notice-board/agm-notice/28-AGM-Notice.jpg";
import agm29 from "../../../files/notice-board/agm-notice/29-AGM-Notice.pdf";
import agm30 from "../../../files/notice-board/agm-notice/30-AGM-Notice.pdf";
import agm31 from "../../../files/notice-board/agm-notice/31-AGM-Notice.pdf";
import agm32 from "../../../files/notice-board/agm-notice/32-AGM-Notice.pdf";
import agm33 from "../../../files/notice-board/agm-notice/33-AGM-Notice.pdf";
import agm34 from "../../../files/notice-board/agm-notice/34-AGM-Notice.pdf";
import agm35 from "../../../files/notice-board/agm-notice/35-AGM-Notice.png";
import agm36 from "../../../files/notice-board/agm-notice/36-AGM-Notice.pdf";

const NoticeBoard = () => {
  return (
    <>
      <div className="notice_board">
        <div className="container">
          <div className="heading_box">Notice Board</div>

          <div className="notice_board_report">
            <div className="row">
              <div className="col-lg-4 mb-4 mb-lg-0">
                <h4>Notices</h4>

                <ul>
                  <li>
                    <a href={cashDividend2023} target="_blank" rel="noreferrer">
                      Cash Dividend 2023
                    </a>
                  </li>

                  <li>
                    <a
                      href={essayCompetition2024}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Essay Competition 2024
                    </a>
                  </li>

                  <li>
                    <a href={cashDividend2022} target="_blank" rel="noreferrer">
                      Cash Dividend 2022
                    </a>
                  </li>

                  <li>
                    <a href={cashDividend2021} target="_blank" rel="noreferrer">
                      Cash Dividend 2021
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-4 mb-4 mb-lg-0">
                <h4>AGM Notice</h4>

                <ul>
                  <li>
                    <a href={agm36} target="_blank" rel="noreferrer">
                      Notice of the 36th AGM 2024{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm35} target="_blank" rel="noreferrer">
                      Notice of the 35th AGM 2023{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm34} target="_blank" rel="noreferrer">
                      Notice of the 34th AGM 2022{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm33} target="_blank" rel="noreferrer">
                      Notice of the 33rd AGM 2021{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm32} target="_blank" rel="noreferrer">
                      Notice of the 32nd AGM 2020{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm31} target="_blank" rel="noreferrer">
                      Notice of the 31st AGM 2019{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm30} target="_blank" rel="noreferrer">
                      Notice of the 30th AGM 2018{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm29} target="_blank" rel="noreferrer">
                      Notice of the 29th AGM 2017{" "}
                    </a>
                  </li>

                  <li>
                    <a href={agm28} target="_blank" rel="noreferrer">
                      Notice of the 28th AGM 2016{" "}
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-4 mb-4 mb-lg-0">
                <h4>Proxy Form</h4>

                <ul>
                  <li>
                    <a href={proxyForm36} target="_blank" rel="noreferrer">
                      36th AGM Proxy Form
                    </a>
                  </li>
                  <li>
                    <a href={proxyForm35} target="_blank" rel="noreferrer">
                      35th AGM Proxy Form
                    </a>
                  </li>

                  <li>
                    <a href={proxyForm34} target="_blank" rel="noreferrer">
                      34th AGM Proxy Form{" "}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoticeBoard;
